import axios from "axios";
import { config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

export const get_all_owner_users = async () => {
    let response = await axios.get(baseURL + '/user-list-for-admin')
    return response.data
}
export const get_single_owner_user_detail = async (id: number) => {
    let response = await axios.get(baseURL + "/user-organizations-for-admin/" + id);
    return response.data;
}
export const delete_owner_user = async (id: number) => {
    let response = await axios.delete(baseURL + "/central-admin/" + id);
    return response.data;
}
export const update_owner_user = async (id: number, formdata) => {
    let response = await axios.post(baseURL + "/update-user/" + id,formdata,config_multipart);
    return response.data;
}
export const get_all_owner_users_paginated = async (
  page: number,
  itemsPerPage: number,
  status?: string,      
  searchTerm?: string  
) => {
  const apiEndpoint = "/user-list-for-admin"; // Or your actual endpoint
  const payload: any = {
    page: page,
    per_page: itemsPerPage,
    // status: status, 
    // search_term: searchTerm, 
  };

  Object.keys(payload).forEach(key => {
    if (payload[key] === "" || payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });
  
  try {
    
    const response = await axios.post(baseURL + apiEndpoint, payload);
    return response;
  } catch (error) {
    console.error("Error fetching owner users:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch owner users');
    }
    throw error;
  }
};